<template>
	<div class="mobile-page-container mobile-padding flex-centerize flex-column">
		<div class="mobile-title mb-3">Ply isn’t supported on mobile yet.</div>
		<SIcon name="edit-configuration-mobile" />
		<div class="mobile-description mt-5">Complete setup from desktop</div>
		<div class="page-description">We just sent you an email reminder to continue when you’re in front of a computer.</div>
	</div>
</template>

<script>
import api from '@/api';
export default {
	name: 'MobileNotSupported',
	methods: {
		sendEmailReminder() {
			api.sendReminderToUseDesktop();
		},
	},
	created() {
		this.sendEmailReminder();
	},
};
</script>

<style scoped lang="scss">
.mobile-page-container {
	width: 100vw;
	height: calc(100vh - calc(100vh - 100%)); // this is hack for 100vh in mobile
	background: var(--setup-node-container-background);
}
.page-description {
	font-size: 16px;
	margin-top: 40px;
	text-align: center;
}
.mobile-title {
	font-size: 26px;
	font-weight: bold;
	text-align: center;
	color: var(--primary-font-color);
}
.mobile-description {
	font-size: 16px;
	font-weight: bold;
	text-align: center;
	color: var(--primary-font-color);
}
.mobile-padding {
	padding: 0px 70px;
}
</style>
